module.exports = __webpack_public_path__ + "media/img/auth/auth-090a6d2b436385f5a18294d094d8b45d.jpg";